import { CART, HOME } from "./actionTypes";

const initialState = {
    page: true
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case HOME:
            return {
                ...state,
                page: true
            };
        case CART:
            return {
                ...state,
                page: false
            };
        default:
            return state;
    }
}